import React, { Component } from 'react';
import ConnectUI from './components/SignIn/Loginform';
import CookieConsent from './components/Style/Cookie';
import './components/Style/AppShell.css';

class App extends Component {
  render() {
    return (
      <>
        <CookieConsent />
        <ConnectUI />
      </>
    );
  }
}

export default App;
